import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {HttpErrorResponse} from '@angular/common/http';
import {SedeEntity, ServicioSedesService} from '../../../../services/servicio-sedes.service';
import {SelectItem} from 'primeng/api';

@Component({
  selector: 'app-header-relacion-admisiones',
  templateUrl: './header-relacion-admisiones.component.html',
  styleUrls: ['./header-relacion-admisiones.component.css']
})
export class HeaderRelacionAdmisionesComponent implements OnInit {

  @Input() codigoBaseDatos: string;
  @Input() uncoSede: number;

  @Output() errorGenerado: EventEmitter<any>;
  @Output() filtrosSeleccionados: EventEmitter<any>;

  sedesItem: SelectItem[] = [];
  puntosAtencionItems: SelectItem[] = [];
  estadosAdmisionItem: SelectItem[] = [{value: 1, label: 'ABIERTO'}, {value: 2, label: 'CERRADO'}, {value: 3, label: 'ANULADO'}, {value: 4, label: 'MODIFICADO'}];
  extenderItems: SelectItem[] = [{value: 1, label: 'Sí'}, {value: 0, label: 'No'}];

  sedesSelected: any[];
  puntosAtencionSelected: any[];
  estadosAdmisionSelected: any[];

  extender = 0;

  fechaInicial: Date;

  fechaFinal: Date;
  mensajeError: string;

  mensajeLoading: string;
  loading: boolean;

  constructor(private servicioSede: ServicioSedesService) {
    this.filtrosSeleccionados = new EventEmitter();
    this.errorGenerado = new EventEmitter();
  }

  ngOnInit() {
    this.getSedes();
  }

  onGenerar() {
    this.filtrosSeleccionados.emit({
      lc_unco_sde_pnto_atncn : this.puntosAtencionSelected,
      lc_unco_estdo_admsn : this.estadosAdmisionSelected,
      ld_fcha_incl: this.fechaInicial,
      ld_fcha_fnl: this.fechaFinal
    });
  }

  onChangeSedes() {
    if (this.sedesSelected.length > 0) {
      this.getPuntosAtencion();
    } else {
      this.clearSedes();
    }
  }

  async getSedes() {
    this.mensajeLoading = 'Cargando sedes...';
    this.loading = true;
    const response = await this.servicioSede.getSedes(this.codigoBaseDatos);

    response.subscribe((sedes: SedeEntity[]) => {

      this.sedesSelected = [];
      sedes.forEach((s: SedeEntity) => {
        this.sedesItem.push({ label: s.descripcion.toUpperCase(), value: s.unco});
      });
      this.mensajeLoading = null;
      this.loading = false;
    }, (err: HttpErrorResponse) => {
      this.mensajeLoading = null;
      this.loading = false;
      this.mensajeError = 'Error grave al intentar cargar las sedes, verifique conexión a internet. De lo contrario reporte caso al administrador.';
      this.clearSedes();
      console.error('Error HeaderRelacionesAdmisiones.getSedes()', err);
    });
  }

  async getPuntosAtencion() {
    this.mensajeLoading = 'Cargando puntos atención...';
    this.loading = true;
    const response = await this.servicioSede.getPuntosAtencion(this.codigoBaseDatos, this.sedesSelected.toString());

    response.subscribe((sedes: any[]) => {

      this.puntosAtencionSelected = [];
      sedes.forEach((s: any) => {
        this.puntosAtencionItems.push({ label: s.dscrpcn, value: s.unco});
      });
      this.mensajeLoading = null;
      this.loading = false;
    }, (err: HttpErrorResponse) => {
      this.mensajeLoading = null;
      this.loading = false;
      this.mensajeError = 'Error grave al intentar cargar las sedes, verifique conexión a internet. De lo contrario reporte caso al administrador.';
      this.clearSedes();
      console.error('Error HeaderRelacionesAdmisiones.getPuntosAtencion()', err);
    });
  }

  private clearSedes() {
    this.sedesSelected = [];
  }

}
